function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  /* margin-right: 0; */\n  &:hover {\n    path {\n      fill: #d7bef2;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Svg from "../Svg";
var IconContainer = styled(Svg).withConfig({
    componentId: "sc-4c5d9870-0"
})(_templateObject());
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(IconContainer, _objectSpread({
        viewBox: "0 0 27 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15.9028 27.125C16.1079 27.125 16.3077 27.0599 16.4734 26.9391C16.6392 26.8183 16.7623 26.6479 16.825 26.4527L17.8907 23.1415C18.3382 22.9226 18.7664 22.6765 19.1752 22.3994L22.5775 23.1318C22.7781 23.1746 22.9871 23.1527 23.1744 23.0691C23.3617 22.9856 23.5177 22.8447 23.6198 22.6668L26.3052 18.0188C26.4078 17.841 26.4512 17.6352 26.4293 17.4312C26.4073 17.2271 26.3211 17.0353 26.1832 16.8834L23.8485 14.3065C23.8825 13.8124 23.8825 13.3165 23.8485 12.8224L26.1832 10.2416C26.3211 10.0897 26.4073 9.89789 26.4293 9.69383C26.4512 9.48978 26.4078 9.28403 26.3052 9.10625L23.6198 4.45625C23.5174 4.27872 23.3613 4.13826 23.174 4.05505C22.9867 3.97184 22.7779 3.95018 22.5775 3.99319L19.1752 4.72556C18.7683 4.45044 18.3382 4.20244 17.8926 3.9835L16.825 0.672314C16.7623 0.477051 16.6392 0.306747 16.4734 0.185928C16.3077 0.0651073 16.1079 5.72205e-06 15.9028 0H10.532C10.3269 5.72205e-06 10.1271 0.0651073 9.96139 0.185928C9.79565 0.306747 9.67254 0.477051 9.60978 0.672314L8.54609 3.98156C8.09973 4.19983 7.6692 4.44909 7.25765 4.7275L3.85734 3.99319C3.65674 3.95036 3.44773 3.97231 3.2604 4.05587C3.07307 4.13944 2.91711 4.28031 2.81497 4.45819L0.129591 9.10625C0.0270478 9.28403 -0.0163863 9.48978 0.00555141 9.69383C0.0274891 9.89789 0.113665 10.0897 0.251653 10.2416L2.58634 12.8224C2.55252 13.3152 2.55252 13.8098 2.58634 14.3026L0.251653 16.8834C0.113665 17.0353 0.0274891 17.2271 0.00555141 17.4312C-0.0163863 17.6352 0.0270478 17.841 0.129591 18.0188L2.81497 22.6688C2.91739 22.8463 3.07348 22.9867 3.26078 23.07C3.44808 23.1532 3.65695 23.1748 3.85734 23.1318L7.25765 22.3975C7.6684 22.6746 8.09853 22.9245 8.54609 23.1434L9.61172 26.4527C9.67427 26.6473 9.7968 26.8172 9.96176 26.9379C10.1267 27.0587 10.3257 27.1242 10.5301 27.125H15.9008H15.9028ZM15.1937 25.1875H11.2412L10.1407 21.7639L9.39859 21.4016C9.03379 21.2231 8.68164 21.0198 8.34459 20.7932L7.65872 20.3283L4.14022 21.0877L2.16397 17.6623L4.57615 14.9924L4.51803 14.1709C4.49019 13.7658 4.49019 13.3592 4.51803 12.9541L4.57615 12.1326L2.16009 9.46275L4.13828 6.03725L7.65678 6.79481L8.34265 6.33175C8.6797 6.10516 9.03186 5.90189 9.39665 5.72338L10.1387 5.36106L11.2412 1.9375H15.1975L16.3019 5.363L17.042 5.72338C17.4064 5.90147 17.758 6.10476 18.0941 6.33175L18.778 6.79481L22.2985 6.03725L24.2747 9.46275L21.8606 12.1326L21.9187 12.9541C21.9466 13.3599 21.9466 13.7671 21.9187 14.1728L21.8606 14.9943L24.2767 17.6623L22.2985 21.0877L18.778 20.3321L18.0941 20.7932C17.758 21.0203 17.4065 21.2236 17.042 21.4016L16.3019 21.762L15.1956 25.1875H15.1937ZM13.2174 19.375C14.759 19.375 16.2374 18.7626 17.3275 17.6726C18.4175 16.5825 19.0299 15.1041 19.0299 13.5625C19.0299 12.0209 18.4175 10.5425 17.3275 9.45244C16.2374 8.36239 14.759 7.75 13.2174 7.75C11.6758 7.75 10.1974 8.36239 9.10735 9.45244C8.01729 10.5425 7.4049 12.0209 7.4049 13.5625C7.4049 15.1041 8.01729 16.5825 9.10735 17.6726C10.1974 18.7626 11.6758 19.375 13.2174 19.375ZM13.2174 17.4375C12.1897 17.4375 11.2041 17.0292 10.4774 16.3025C9.75066 15.5758 9.3424 14.5902 9.3424 13.5625C9.3424 12.5348 9.75066 11.5492 10.4774 10.8225C11.2041 10.0958 12.1897 9.6875 13.2174 9.6875C14.2451 9.6875 15.2307 10.0958 15.9574 10.8225C16.6841 11.5492 17.0924 12.5348 17.0924 13.5625C17.0924 14.5902 16.6841 15.5758 15.9574 16.3025C15.2307 17.0292 14.2451 17.4375 13.2174 17.4375Z",
            fill: "black"
        })
    }));
};
export default Icon;
